import React, { useState, useEffect } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
// Register necessary components for Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
  plugins: {
    legend: {
      display: true, 
      position: 'bottom', 
      align: 'center', 
      labels: {
        padding: 15, 
        boxWidth: 7, 
        boxHeight: 7,
        usePointStyle: true,
      },
      title: {
        display: false,
        padding: 0,
      },
    },
    datalabels: {
      formatter: (value, ctx) => {
        const dataset = ctx.chart.data.datasets[0];
        const total = dataset.data.reduce((acc, val) => acc + val, 0);
        const percentage = ((value / total) * 100).toFixed(1);
        return `${percentage}%`;
      },
      color: '#fff',
    },
    tooltip: {
      callbacks: {
        label: function(tooltipItem) {
          return tooltipItem.label + ': ' + tooltipItem.raw;
        }
      }
    }
  },
  responsive: true,
  cutout: '50%' // This creates the donut effect
};


function ResponseBy({data}) {
  const [responseByData, setResponseByData] = useState({});
  useEffect(() => {
    setResponseByData(data || {});
  }, [data]);
  const byData = {
    labels: ['Mobile', 'Web'],
    datasets: [
      {
        // label: 'Dataset 1',
        data: [responseByData.MobileCount, responseByData.WebCount],
        backgroundColor: [
          '#04559f',
          '#008000',
          '#e31f2b',
        ],
        borderWidth: 0
      }
    ]
  };

  return (
    <div style={{height:'178px'}}>
      <Pie data={byData} options={options} />
    </div>
  );
}

function ResponseThrough({ data }) {
  const [responseThroughData, setResponseThroughData] = useState({});
  useEffect(() => {
    setResponseThroughData(data || {});
  }, [data]);
  const throughtdata = {
    labels: ['SMS', 'WhatsApp', 'Others'],
    datasets: [
      {
        // label: 'Dataset 1',
        data: [responseThroughData.SmsCount, responseThroughData.WhatsappCount, responseThroughData.OthersCount],
        backgroundColor: [
          '#04559f',
          '#008000',
          '#e31f2b',
        ],
        borderWidth: 0,
      }
    ]
  };
  

  return (
    // <div className="mt-2" style={{height:'215px', width: '400px'}}>
      <Pie data={throughtdata} options={options} />
    // </div>
  );
}

function ResponseType({ data }) {
  const [responseTypeData, setResponseTypeData] = useState({});
  useEffect(() => {
    setResponseTypeData(data || {});
  }, [data]);
  const typedata = {
    labels: ['Invitation', 'Reminders'],
    datasets: [
      {
        label: 'Dataset 1',
        data: [responseTypeData.InvitationCount, responseTypeData.ReminderCount],
        backgroundColor: [
          '#04559f',
          '#008000',
          '#e31f2b',
        ],
        borderWidth: 0
      }
    ]
  };

  return (
    // <div className='mb-2' style={{height:'200px', width: '350px'}}>
      <Pie data={typedata} options={options} />
    // </div>
  );
}

export {
  ResponseBy,
  ResponseThrough,
  ResponseType,
};
